import {
    AutoComplete,
    Input,
    Row,
    Col,
    Spin,
    Avatar,
    Image
} from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useEffect, useMemo, useState } from 'react';
import { createSearchModule } from '@/modules/search';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { store } from '@/configureStore';
import Button from '../ui/Button';
import { ImageWithFallback } from '../common/Image';

const StyledSearchData = styled.div`
    display:flex;
    margin: 10px 0 10px 0;
    .search-data-item-selected{
        border: 2px solid var(--primary-main-color);  
    
    }
    .search-data-item-selected:hover {
        box-shadow: 0 0 8px rgba(192,192,192,.8); 
        border: 1px solid var(--primary-main-color);  
    }
    .show-all-button {
       margin-top: 26px;
       font-size: 16px;
       line-height: 20px;
       font-weight: 700;
    }
`

const StyledSearchItem = styled.div`
    @media (max-width: 420px) {
        width: 140px;
        height: 160px;
    }
    width: 160px;
    height: 180px;

    margin-top: 16px;
    border: 1px solid #C0C0C0;
    border-radius: 16px;
    .search-data-button{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0px;
        gap: 18px;
        background-color: transparent; 
        color: none;
        border: none;
        width: 160px;
        height: 180px;
        @media (max-width: 420px) {
            width: 140px;
            height: 160px;
        }
    
    }

    :hover {
        box-shadow: 0 0 8px rgba(192,192,192,.8); 
        border: 1px solid #C0C0C0;  
    }
    .search-data-image{
        border: none;
        display: flex;
        width: 72px;
        height: 96px;
        @media (max-width: 420px) {
            width: 65px;
            height: 86px;
        }
    }
    .search-data-name{
        display: flex;
        font-weight: 400;
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 150%;
        letter-spacing: 0.01em;
        color: #707070;
    }
`

const StyledButton = styled.button`
`

const StyledImage = styled(ImageWithFallback)`
    
`
const StyledSpan = styled.span`
`
const StyledSearchInput = styled(Input)`
    border: 1px solid #C0C0C0 !important;
    border-radius: 24px !important;
    height: 40px;
    .anticon{
        color: var(--primary-main-color)
    }
`


const StyledAutoComplete = styled(AutoComplete)`
    width:100%;
    @media (min-width: 768px) {
        width: 600px;
    }
    @media (min-width: 768px) {
        .search-input, .ant-select {
            min-width: 600px;
            max-width: 600px;
            width: 600px;
        }
    }
    .ant-select, .search-input {
        @media (min-width: 768px) {
            min-width: 600px;
            max-width: 600px;
            width: 600px;
        }
        min-width:100%;
        min-height: 40px;

        width: 100%;
        border: 1px solid #C0C0C0 !important;
        border-radius: 24px !important;
        .anticon{
            color: var(--primary-main-color);
        }
    }

`
const InlineSearch = ({ options, onSelect }) => {
    const defaultOnSelect = (value) => console.log('selected', value)
    return <StyledAutoComplete
        options={options}
        maxTagCount={10}
        onSelect={onSelect || defaultOnSelect}
        filterOption={(inputValue, option) =>
            option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
        }
    >
        <StyledSearchInput
            placeholder="Zoek model, merk..."
            // prefix={<SearchOutlined />}
            suffix={<SearchOutlined />}
            allowClear
            className="search-input"
        />
    </StyledAutoComplete>
}

const SearchInput = ({ searchModule, searchPlaceholder }) => {
    const [inputValue, setInputValue] = useState()
    useEffect(() => {
        const val = searchModule.selector(store.ref?.getState())?.inputValue
        if (val) {
            // console.log(`existing val ${val}`)
            setInputValue(val)
        }
    }, [])
    // const {inputValue} = useSelector(searchModule.selector);
    const onSearch = (e) => {
        const searchValue = e.target.value
        // console.log(searchValue)
        searchModule.actions.updateInputValue(searchValue)
        setInputValue(searchValue)
        // searchModule.actions.search()
    }
    return <StyledSearchInput
        placeholder={searchPlaceholder || "Search..."}
        prefix={<SearchOutlined />}
        allowClear
        onChange={onSearch}
        className="search-input"
        value={inputValue}
    />

}

const SearchItemContent = ({ item, searchModule }) => {
    return <>
        <StyledImage mainSrc={item.image} fallback={searchModule.defaultImage} className="search-data-image" />
        <StyledSpan className='search-data-name'>{item.name}</StyledSpan>
    </>
}
const SearchDataItem = ({ item, searchModule, isSelected, SearchItemContent }) => {
    // console.log(item)
    const image = item.image
    const name = item.name
    const onSelect = (item) => {
        // console.log(`selected item ${item.id} - ${item.name}`)
        // console.log(searchModule)
        searchModule.actions.updateSelectedItem(item)
    }
    return <StyledSearchItem key={item.id} className={isSelected ? "search-data-item search-data-item-selected" : "search-data-item"}>
        <StyledButton className='search-data-button'
            onClick={(e) => {
                e.preventDefault()
                onSelect(item)
            }}>
            <SearchItemContent item={item} searchModule={searchModule} />
        </StyledButton>
    </StyledSearchItem>
}

const SearchResults = ({ searchModule, maxItems, SearchItemContent }) => {
    const { results, selectedItem, isLoading } = useSelector(searchModule.selector);
    const [showTotal, setShowTotal] = useState(false)
    const [noOfResults, setNoOfResults] = useState()
    useEffect(() => {
        if (results) {
            const isShowTotal = maxItems && maxItems > 0 && maxItems < results.length
            setShowTotal(isShowTotal)
            const noOfResults = isShowTotal ? maxItems : results.length;
            setNoOfResults(noOfResults)
        }

    }, [maxItems, results])
    if (!results) {
        return <div style={{ deisplay: 'none' }}></div>
    }
    // console.log('selected item')
    // console.log(selectedItem)
    // console.log(`is loading ${isLoading}`)

    if (isLoading) {
        // console.log('loading results...')
        return <Spin style={{ margin: "10px" }} />
    }
    const getResults = () => {
        return results.slice(0, noOfResults)
    }

    const filteredResults = getResults()
    const handleShowAll = () => {
        setNoOfResults(results.length)
        setShowTotal(false)
    }
    return <StyledSearchData>
        <Row type="flex" gutter={20} className='search-data' justify="start">
            {filteredResults.map(item => {
                let isSelected = false
                if (selectedItem && item.id === selectedItem.id) {
                    // console.log(`selected item ${item.name}`)
                    isSelected = true
                }
                return <Col key={item.id} className="search-data-item-col">
                    <SearchDataItem
                        item={item}
                        searchModule={searchModule}
                        isSelected={isSelected}
                        SearchItemContent={SearchItemContent}
                    />
                </Col>
            })}
            <Col span={24} style={{ display: 'flex', justifyContent: 'center', alignItems: "center" }}>
                {showTotal && <Button className='show-all-button'
                    onClick={handleShowAll} >
                    TOON ALLE {results.length} REPARATIES
                </Button>}
            </Col>
        </Row>
    </StyledSearchData>

}
SearchResults.defaultProps = {
    SearchItemContent: SearchItemContent,
}
export {
    SearchInput,
    StyledImage,
    StyledSpan,
    InlineSearch,
    SearchResults,
};
